import React from 'react';

const AboutPage = ({ setActiveTab }) => {
  return (
    <div className="about-container">
      <div className="about-header">
        <h1>Nosotros</h1>
        <p>Conoce al equipo que está revolucionando el mercado inmobiliario en Costa Rica</p>
      </div>

      {/* Company Story */}
      <div className="company-story-section">
        <div className="story-content">
          <h2>Nuestra Historia</h2>
          <p>
            Link Real Estate nació de la frustración de buscar propiedades usando herramientas 
            obsoletas de los años 90. Cansados de filtros limitados, búsquedas que no entendían 
            lo que realmente queríamos, y la sensación constante de que se nos escapaba la 
            propiedad perfecta.
          </p>
          <p>
            Decidimos crear algo diferente: una plataforma que entiende el lenguaje humano, 
            que rastrea toda la web en busca de oportunidades, y que conecta a las personas 
            con sus hogares ideales de manera inteligente y eficiente.
          </p>
        </div>
      </div>

      {/* Team Values */}
      <div className="values-section">
        <h2>Nuestros Valores</h2>
        <div className="values-grid">
          <div className="value-card">
            <div className="value-icon">🚀</div>
            <h3>Innovación</h3>
            <p>Utilizamos la tecnología más avanzada para resolver problemas reales del mercado inmobiliario</p>
          </div>
          
          <div className="value-card">
            <div className="value-icon">🎯</div>
            <h3>Precisión</h3>
            <p>Cada búsqueda, cada recomendación, cada valuación está respaldada por datos y algoritmos inteligentes</p>
          </div>
          
          <div className="value-card">
            <div className="value-icon">🤝</div>
            <h3>Transparencia</h3>
            <p>Creemos en procesos claros, precios justos y comunicación honesta en cada transacción</p>
          </div>
          
          <div className="value-card">
            <div className="value-icon">⚡</div>
            <h3>Eficiencia</h3>
            <p>Tu tiempo es valioso. Por eso automatizamos procesos y eliminamos pasos innecesarios</p>
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div className="team-section">
        <h2>Nuestro Equipo</h2>
        <div className="team-grid">
          <div className="team-member">
            <div className="member-avatar">👨‍💻</div>
            <h3>Equipo de Tecnología</h3>
            <p>Desarrolladores e ingenieros especializados en IA y machine learning</p>
          </div>
          
          <div className="team-member">
            <div className="member-avatar">🏠</div>
            <h3>Expertos Inmobiliarios</h3>
            <p>Profesionales con años de experiencia en el mercado costarricense</p>
          </div>
          
          <div className="team-member">
            <div className="member-avatar">📊</div>
            <h3>Analistas de Datos</h3>
            <p>Especialistas que interpretan tendencias y patrones del mercado</p>
          </div>
        </div>
      </div>

      {/* AI Advantage */}
      <div className="ai-advantage-section">
        <h2>¿Por qué nuestra IA marca la diferencia?</h2>
        <div className="advantage-content">
          <p>
            Nuestro asistente de inteligencia artificial no es solo un chatbot más. 
            Es el resultado de una base de datos exhaustiva que lo ha entrenado específicamente 
            para entender el mercado inmobiliario costarricense.
          </p>
          
          <div className="ai-features">
            <div className="ai-feature">
              <h4>🧠 Comprensión Contextual</h4>
              <p>Entiende no solo lo que dices, sino lo que realmente necesitas</p>
            </div>
            
            <div className="ai-feature">
              <h4>🔍 Búsqueda Exhaustiva</h4>
              <p>Rastrea múltiples fuentes para no perder ninguna oportunidad</p>
            </div>
            
            <div className="ai-feature">
              <h4>📈 Aprendizaje Continuo</h4>
              <p>Mejora constantemente con cada interacción y transacción</p>
            </div>
          </div>
          
          {/* <button 
            className="button-primary ai-demo-btn"
            onClick={() => setActiveTab('chatbot')}
          >
            Probar Nuestro Asistente IA
          </button> */}
        </div>
      </div>

      {/* Contact CTA */}
      <div className="contact-cta-section">
        <div className="cta-content">
          <h2>¿Quieres conocer más sobre nosotros?</h2>
          <p>Estamos aquí para responder todas tus preguntas</p>
          <button 
            className="button-primary"
            onClick={() => setActiveTab('contact')}
          >
            Contáctanos
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
